import axios from 'services/index';
import config from 'config/config';

/**
 * Get a list of bookings
 * @param {Object} params
 * @param {String} productId
 * @param {String} quotedProductId
 *
 * Example: portal/booking/ea710d34-7b57-4d84-9cd6-0808f275b1e1/upload_engraving/a72b756a-a8ca-4ad0-aa9d-a9e03e797a18
 */
export async function uploadEngraving(params, actualProductId) {
    if (!sessionStorage.getItem(config.GUEST_TOKEN)) {
        return axios.post(
            `${config.API_URL}portal/booking/upload_engraving/${actualProductId}`,
            {
                params,
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    const token = sessionStorage.getItem(config.GUEST_TOKEN);
    return axios.post(
        `${config.API_URL}portal/booking/upload_engraving/${actualProductId}`,
        {
            params,
            headers: {
                'Content-Type': 'application/json'
            }
        }, {
            headers: {
                authorization: `Bearer ${token}`,
                common: {
                    Brand: `${config.BRAND}`
                }
            }
        }
    );
}

/**
 * Get a list of bookings
 * @param {Object} params
 */
export async function getBookings(params) {
    return axios.get(
        `${config.API_URL}portal/booking`,
        {
            params,
            headers: { 'Content-Type': '' }
        }
    );
}

/**
 * Get the list of service types of the vet
 * @param {Object} params
 */
export async function getVetServices(params) {
    return axios.get(
        `${config.API_URL}portal/booking/service_types`,
        {
            params,
            headers: { 'Content-Type': '' }
        }
    );
}

/**
 * Get the map of order stages
 * @return {Object} Object of order stages
 */
export async function getOrderStages() {
  const response = await fetch(`${config.SUGAR_API}public/dropdown/vet_facing_string_map`, {
    method: 'GET',
    // credentials: 'include', // Uncomment if you need to send cookies
    // headers: { 'Content-Type': 'application/json' }, // Usually not needed for GET
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
}

/**
 * Get the booking
 * @param {Object} bookingId The vetId to retrieve its team members
 * @param {int} staff Is the request coming from a staff? if yes, staff = 1. if no, staff = 0 (client)
 */
export async function getBooking(bookingId, staff = 1) {
    if (staff === 1) {
        return axios.get(`${config.API_URL}portal/booking/${bookingId}`);
    }

    const token = sessionStorage.getItem(config.GUEST_TOKEN);
    return axios.get(`${config.API_URL}portal/booking/${bookingId}`, {
        headers: {
            authorization: `Bearer ${token}`,
            common: {
                Brand: `${config.BRAND}`
            }
        }
    });
}

/**
 * Get the booking without authentication
 * @param {Object} bookingId The vetId to retrieve its team members
 */
export async function getBookingWithoutAuth(bookingId) {
    return axios.get(`${config.API_URL}portal/authentication/${bookingId}`);
}

/**
 * Get the booking image
 * @param {Object} bookingId 
 * @returns {Promise<AxiosResponse>}
 */
 export async function getImage(bookingId) {
    return axios.get(
        `${config.API_URL}portal/booking/image/${bookingId}`,
        {
            headers: { 'Content-Type': '' }
        }
    );
}

/**
 * Creates a new booking
 * @param {Object} data An object with the booking data
 */
export async function createBooking(bookingData) {
    return axios.post(`${config.API_URL}portal/booking`, bookingData);
}

/**
 * Updates a booking
 * @param {string} bookingId The booking id
 * @param {Object} bookingData An object with the booking data
 */
export async function editBooking(bookingId, bookingData) {
    if (!bookingId) {
        return;
    }
    return axios.post(`${config.API_URL}portal/booking/${bookingId}`, bookingData);
}

/**
 * Creates a new special instruction
 * @param {string} bookingId The booking id
 * @param {string} specialInstruction The special instruction as a string
 */
export async function addSpecialInstruction(bookingId, specialInstructions) {
        const data = {
        opportunity_id: bookingId,
        special_instructions: specialInstructions.map((item) => ({
            description: item.name,
            opportunity_id: bookingId,
            completed: false,
            id: item.id
        }))
    };

    return axios.post(`${config.API_URL}portal/special_instruction`, data);
}

/**
 * Complete booking
 * @param {string} bookingId The booking id
 * @param {Object} additionalData Additional data for completing the booking
 */
export async function completeBooking(bookingId, additionalData) {
    const data = {
        screenshot_image: additionalData.screenshotImage ?? '',
    };

    return axios.post(`${config.API_URL}portal/booking/${bookingId}/complete`, data);
}

/**
 * Submit the add booking vet supply order
 * @param {Array} items list of object items to submit
 */
// eslint-disable-next-line import/prefer-default-export
export async function addBookingVetSupply(items) {
    return axios.post(`${config.API_URL}portal/vet_supply`, items);
}
